import { makeStyles } from "tss-react/mui";

export const useHeaderMenuFileItemStyles = makeStyles()((theme) => ({
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minWidth: "240px",
    width: "100%",
  },

  leftSide: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },

  text: {
    color: theme.palette.text.primary,
  },

  fab: {
    pointerEvents: "none",
  },
}));

export default useHeaderMenuFileItemStyles;
